import { unknownToString } from "./unknown.ts";

// JWT segments are base64url-encoded (RFC 7515 §2): the standard base64 alphabet
// with `+`/`/` replaced by `-`/`_` and trailing `=` padding stripped. `atob`
// only understands standard base64, so a real token whose payload happens to
// contain `-` or `_` throws `InvalidCharacterError` unless we convert first.
// (jsdom's lenient `atob` accepts these, which is why this hid in tests but
// broke on real browsers/devices.)
function decodeBase64Url(value: string): string {
	const base64 = value.replace(/-/g, "+").replace(/_/g, "/");
	// `atob` is forgiving about the missing padding, so no need to re-pad.
	return atob(base64);
}

function decodeJwt(token: string): unknown {
	const [, payload] = token.split(".");
	try {
		return JSON.parse(decodeBase64Url(payload));
	} catch (e) {
		throw new Error(`Invalid JWT ${unknownToString(e)}`);
	}
}

export { decodeJwt, decodeBase64Url };
